// Глобальная реакция на истёкшую сессию.
//
// Проблема (night_watch 2026-07-03): вкладка с умершей сессией продолжала молотить
// по API (SSE-reconnect + поллинги) — 115+ мусорных 401/403/406 в сутки.
// Решение: базовые fetch-слои (csrfFetch, apiClient) репортят сюда 401; AuthContext
// слушает событие и сбрасывает isAuthenticated — все поллеры/стримы останавливаются
// своими же guard'ами, роутинг уводит на /login.

export const SESSION_EXPIRED_EVENT = 'crm:session-expired';

let reported = false;

/** Один репорт на «эпизод» — чтобы шторм параллельных 401 не спамил событиями. */
export function reportSessionExpired(source: string): void {
  if (reported) return;
  // На странице логина 401 — это «неверный пароль», а не истёкшая сессия.
  if (window.location.pathname.startsWith('/login')) return;
  reported = true;
  console.debug('[session-expiry] reported', { source });
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { source } }));
}

/** Сбросить после успешного логина/восстановления сессии. */
export function resetSessionExpired(): void {
  reported = false;
}
